import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';


const ImagesFolderList = ({ loadingFolderId, handleFolderClick, folders, setSelectedFolderId, selectedFolderId, setFilesData }) => {

    const renderFolder = (node) => {
        const isLoading = loadingFolderId === node.folderId;

        return <TreeItem
            key={node.folderId}
            itemId={node.folderId}
            label={
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pr: 1,
                        "& .folder-actions": { visibility: "hidden" },
                    }}
                >
                    <Typography sx={{ fontSize: "13px", display: "flex", alignItems: "center", gap: 1 }}><FolderIcon /> {node.folderName}</Typography>
                    {isLoading && <CircularProgress size={14} sx={{ color: "#00344C" }} />}

                </Box>
            }
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setFilesData(node?.files || [])
                handleFolderClick(node);

            }}
        >
            {Array.isArray(node.children)
                ? node.children.map((child) => renderFolder(child))
                : null}
        </TreeItem>
    };

    return (
        <Paper
            sx={{
                width: "100%",
                //minWidth: 240,
                p: 1.5,
                borderRadius: 2,
                overflow: "auto",
                border: "1px solid #eef0f4",
                boxSizing: "border-box",
                height: "100%",
                maxHeight: "420px"
            }}
        >
            <Typography sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 600,
                fontSize: '20px',
                letterSpacing: "0px",
                mb: 0,
                color: "#111827",
            }}>Folders</Typography>
            <Divider sx={{ my: 1 }} />

            {folders?.length > 0 ? <SimpleTreeView
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                selectedItems={selectedFolderId || null}
                onSelectedItemsChange={(event, itemId) => {
                    if (itemId) {
                        setSelectedFolderId(itemId);
                        // setSelectedDocId(null);
                    }
                }}
                sx={{
                    "& .MuiTreeItem-label": { fontSize: "13px" },
                    // Ensure that focused but NOT selected items don't look selected
                    // "& .MuiTreeItem-content.Mui-focused:not(.Mui-selected)": {
                    //     backgroundColor: "transparent",
                    // },
                }}
            >
                {folders.map((n) => renderFolder(n))}
            </SimpleTreeView> : <Box
                sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6b7280",
                    fontSize: "16px",
                    fontWeight: 500,
                }}
            >
                No Folders
            </Box>}
        </Paper>
    )
}

export default ImagesFolderList
